











import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { appStore } from '@/store'

@Component
export default class AtomLinkButton extends ComponentVue {
  @Prop({ type: String, default: '#' })
  href!: string

  @Prop({ type: Boolean, default: false })
  blank!: boolean

  @Prop({ type: Boolean, default: false })
  bold!: boolean

  @Prop({ type: Boolean, default: false })
  small!: boolean

  @Prop({ type: Boolean, default: false })
  large!: boolean

  @Prop({ type: Boolean, default: false })
  extraLarge!: boolean

  @Prop({ type: Boolean, default: false })
  danger!: boolean

  get classes(): object {
    return {
      _bold: this.bold,
      _small: this.small,
      _danger: this.danger,
      _default: !this.small && !this.large && !this.extraLarge,
      _large: this.large,
      _extraLarge: this.extraLarge
    }
  }

  get styles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  @Emit('click')
  onClick() {
    if (this.blank) {
      window.open(this.href, '_blank')
      return
    }

    if (this.href !== '#') {
      this.$router.push(this.href)
    }
  }
}
